
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b6nGj", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=ko.74a883e0.js.map
